<template>
  <div class="pfol row">
    <div class="pfol__header small-12">
      {{ $t('tenantProjects.comments') }}
    </div>
    <div class="pfol__main small-12">
      <div
        v-if="postFitoutComments.length"
        class="pfol__body"
      >
        <div
          v-for="(item, index) in postFitoutComments"
          class="pfol__history-item row"
          :key="index"
        >
          <div
            class="pfol__history-title"
            @click="() => showCommentsDetail(item)"
          >
            {{ $t('tenantProjects.postFitout.titleWithNumber', [item.order ? item.order + 1: '']) }}
          </div>
          <div class="tip small-5">
            <div class="tip__text">
              {{ getCommentActionText(item) }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="hint"
      >
        {{ $t('tenantProjects.postFitout.noLetterHint') }}
      </div>
    </div>
    <HKLModal
      ref="tenantPreviewModalRef"
      size="large"
      :closable="true"
      :dialogStyle="{'top':'0'}"
    >
      <CommentsPreviewBody
        :isBatchesView="false"
        :activeBatch="activeBatch"
        :showRecipientsReadOnly="true"
      />
      <TenantSubmissionDocuments
        :files.sync="files"
        :sourceId="(currentBatch || {}).id || ''"
        :canEdit="false"
      />
      <div slot="footer" />
    </HKLModal>
  </div>
</template>

<script>
import _ from 'lodash'
import { computed, getCurrentInstance, ref } from '@vue/composition-api'
import dateUtil from '@/utils/dateUtil'

import { useStoreState } from '@/store'
import HKLModal from '@/controls/Modal/HKLModal'
import CommentsPreviewBody from '../submissions/CommentsPreviewBody.vue'
import TenantSubmissionDocuments from '../submissions/TenantSubmissionDocuments'

import { formatActiveBatch } from './hook'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { PF_HISTORY_ACTION_TYPE } from './consts'

export default {
  components: {
    HKLModal,
    CommentsPreviewBody,
    TenantSubmissionDocuments,
  },

  setup () {
    const state = useStoreState()
    const files = ref([])
    let currentBatch = ref({})
    const { proxy } = getCurrentInstance()

    const tenantPreviewModalRef = useRefModal()

    const postFitoutComments = computed(() => {
      const completedPostFitouts = _.get(state.value, 'postFitoutSubmission.postFitouts', []).filter(item => item.completedDate)
      return _.orderBy(completedPostFitouts, 'createdAt', 'desc')
    })

    const showCommentsDetail = (item) => {
      currentBatch.value = item
      tenantPreviewModalRef.open()
    }

    const getCommentActionText = (item) => {
      const sendHistory = item.histories.find(history => history.actionType === PF_HISTORY_ACTION_TYPE.SEND)
      const completedDate = dateUtil.formatDate(sendHistory.createdAt, true)
      return proxy.$t('tenantProjects.submission.receivedOn', [completedDate])
    }
    const activeBatch = formatActiveBatch(currentBatch)

    return {
      showCommentsDetail,
      getCommentActionText,
      postFitoutComments,
      activeBatch,
      files,
      currentBatch,
      tenantPreviewModalRef: tenantPreviewModalRef.modal,
    }
  },
}

</script>

<style lang="scss" scoped>
@import './style.scss';
.pfol__main {
  min-height: 60px;

.hint {
  text-align: center;
  font-style: italic;
  font-weight: normal;
  margin-top: 30px;
  }
  .pfol__history-item {
  border: 1px solid #e0e1e4;
  color: #0c3a58;
  padding: 9px 14px 11px 17px;
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
.pfol__history-title {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
}

</style>
